module.exports = __webpack_public_path__ + "img/downimg_bg04.8be2506a.png";